import React from "react";
import { TableRowField } from "../../../../components";
import { formatHelper } from "../../../../common/helpers";
import { toMoney } from "../../../../common/helpers/format";

export const formatSellDetail = (sellDetails) => {
  let buffer = [];

  sellDetails.forEach((element) => {
    if (element.Offer) {
      buffer.push(
        <span>
          {element.quantity} x {element.Offer.name}{" "}
          <b>(s/{toMoney(element.total_net)})</b>,{" "}
        </span>
      );
    } else {
      buffer.push(<span>{element.quantity} x Sin Servicio,</span>);
    }
  });
  return buffer;
};

export const columnsOfferDetailsXS = [
  {
    dataField: "xs",
    text: "Balance por Oferta Detallado",
    formatter: (cell, row) => {
      const sellDetail = formatSellDetail(row.sellDetails);
      return (
        <div>
          <TableRowField label="Concepto:" value={sellDetail} />
          <TableRowField label="Cliente:" value={row.customer} />
          <TableRowField label="Empleados:" value={row.employee} />
          <TableRowField label="Forma de Pago:" value={row.paymentMethod} />
          <TableRowField
            label="Total (S/):"
            value={formatHelper.toMoney(row.total)}
          />
        </div>
      );
    },
  },
];
export const columnsOfferDetailsSM = [
  {
    dataField: "xs",
    text: "Balance por Oferta Detallado",
    formatter: (cell, row) => {
      const sellDetail = formatSellDetail(row.sellDetails);
      return (
        <div>
          <TableRowField label="Concepto:" value={sellDetail} />
          <TableRowField label="Cliente:" value={row.customer} />
          <TableRowField label="Empleados:" value={row.employee} />
        </div>
      );
    },
  },
  {
    dataField: "payment",
    text: "Forma de Pago",
    formatter: (cell, row) => {
      return (
        <div>
          <TableRowField label="Forma de Pago:" value={row.paymentMethod} />
        </div>
      );
    },
  },
  {
    dataField: "total_net_sell_detail",
    text: "Total (S/)",
    formatter: (cell, row) => {
      return (
        <div>
          <TableRowField label="" value={formatHelper.toMoney(row.total)} />
        </div>
      );
    },
  },
];

export const columnsOfferDetailsMD = [
  {
    dataField: "offer",
    text: "Concepto",
    formatter: (cell, row) => {
      const sellDetail = formatSellDetail(row.sellDetails);
      return (
        <div>
          <TableRowField label="" value={sellDetail} />
        </div>
      );
    },
  },
  {
    dataField: "client",
    text: "Cliente",
    formatter: (cell, row) => {
      return (
        <div>
          <TableRowField label="" value={row.customer} />
        </div>
      );
    },
  },
  {
    dataField: "employee",
    text: "Empleados",
    formatter: (cell, row) => {
      return (
        <div>
          <TableRowField label="" value={row.employee} />
        </div>
      );
    },
  },
  {
    dataField: "payment",
    text: "Forma de Pago",
    formatter: (cell, row) => {
      return (
        <div>
          <TableRowField label="" value={row.paymentMethod} />
        </div>
      );
    },
  },
  {
    dataField: "total",
    text: "Total (S/)",
    formatter: (cell, row) => {
      return (
        <div>
          <TableRowField label="" value={formatHelper.toMoney(row.total)} />
        </div>
      );
    },
  },
];



// WEBPACK FOOTER //
// ./src/scenes/Report/Balance/OfferBalance/_columns.js